import type {
  EnumDefinitionCreateOperation,
  EnumDefinitionInOut,
  EnumLiteralCreateOperation,
  EnumLiteralInOut,
} from '@festina/configuration-general-types/configuration'
import { assertNotEmpty } from '@festina-life/core'

import type {
  EnumDefinition,
  EnumLiteral,
  ModeledEnumLiteral,
} from '../../uiModels/enumLiterals/types'

export const toEnumLiteralCreateOperation = (
  literal: ModeledEnumLiteral,
): EnumLiteralCreateOperation => ({
  _type: 'EnumLiteralCreateOperation',
  entity: {
    _type: 'EnumLiteralInOut',
    deprecated: false,
    enumName: literal.enumDefinition.typeName,
    name: literal.literalName,
    description: null,
  } satisfies EnumLiteralInOut,
})

export const workspaceOperationFromEnumLiteral = (literal: EnumLiteral) => {
  if (literal.type === 'configured') {
    const operationClone = structuredClone(literal.internalOperation)

    if (literal.isDraft) {
      return operationClone
    } else {
      // If it's not a draft we should create a new operation in the workspace with a different operationKey.
      operationClone.operationKey = undefined

      return operationClone
    }
  } else {
    return toEnumLiteralCreateOperation(literal)
  }
}

const emptyEnumDefinitionOperation = (
  forName: string,
): EnumDefinitionCreateOperation => ({
  _type: 'EnumDefinitionCreateOperation',
  entity: { _type: 'EnumDefinitionInOut', name: forName, description: '' },
})

export const workspaceOperationFromEnumDefinition = (
  definition: EnumDefinition,
) => {
  const operationClone = definition.internalOperation
    ? structuredClone(definition.internalOperation)
    : emptyEnumDefinitionOperation(definition.name)

  if (definition.isDraft) {
    return operationClone
  } else {
    // If it's not a draft we should create a new operation in the workspace with a different operationKey.
    operationClone.operationKey = undefined

    return operationClone
  }
}

export const cloneEnumDefinitionWithValue = (
  currentDefinition: EnumDefinition,
  entity: EnumDefinitionInOut,
): EnumDefinition => {
  assertNotEmpty(currentDefinition.internalOperation)

  return {
    ...currentDefinition,
    internalOperation: {
      ...currentDefinition.internalOperation,
      entity,
    },
  }
}
